import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DbSnapshotsPage } from 'pages/db-snapshots/db-snapshots';

@NgModule({
    declarations: [DbSnapshotsPage],
    imports: [PagesModule, ComponentsModule],
    exports: [DbSnapshotsPage]
})
export class DbSnapshotsPageModule {}
